import React, { Component } from "react";

import Video from "../../Components/Video";

class HetAmazonenwoud extends Component {
  render() {
    return (
      <div className="het-amazonen-woud">
        <Video video={"https://www.youtube.com/embed/vuQXjR5FscM"} />
      </div>
    );
  }
}

export default HetAmazonenwoud;
